module.exports = __webpack_public_path__ + "img/link-banner-kr.37f8ee87.png";